<template>
  <div class="homepage-personal-info">
    <div class="content">
      <div
        class="info-top"
        :class="{ pg: isConsultTeacher && isQingtingTeacher }"
      >
        <img
          :src="basicInfo.avatar | imgZip(100)"
          class="top-avatar"
          @click="showImgViewer"
        />
        <dataPanel />
      </div>
      <div class="info-base">
        <div class="name-and-level">
          <div class="name" :class="{ m: zxProTeacher && qingsuLevel }">
            {{ basicInfo.nickname }}
          </div>
          <span
            v-if="zxProTeacher"
            class="zxteacher"
            @click="openStandardPopup"
          >
            <i></i>
            {{ zxProTeacher.name }}</span
          >
          <img
            v-if="qingsuLevel"
            class="qingsu-level"
            @click="onClickQingsuLevel"
            :src="
              require(`../../../../images/platform/homepage/icon-level-${qingsuLevel}.png`)
            "
          />
        </div>
        <div
          v-if="isConsultTeacher || isQingtingTeacher"
          class="business-card"
          :class="{ 'qingsu-own': isQingtingTeacher && !isConsultTeacher }"
          @click="handleClickNamecard"
        >
          <i></i>
          <span>名片</span>
        </div>
        <normalRelation v-else-if="!isMyself" v-on="$listeners" />
      </div>

      <div v-if="isConsultTeacher || isQingtingTeacher">
        <ul
          v-if="consutTagList.length"
          class="tags-view"
          :class="{ m: isShowAllTags }"
        >
          <li
            v-for="tag in consutTagList.slice(0, 3)"
            :key="tag.title"
            :style="{ 'paddin-left': !tag.icon ? '0.12rem' : '' }"
            @click.stop="onTagClick(tag, 'consult')"
            class="consult-tag"
          >
            <img
              v-if="tag.icon"
              :src="tag.icon"
              alt=""
              :style="{ 'margin-top': isPc ? '-0.004rem' : '0' }"
            />
            <span>{{ tag.title }}</span>
          </li>
          <van-icon
            v-if="isShowAllTags"
            name="arrow"
            class="icon-arrow"
            @click="showAllTags"
          />
        </ul>
        <ul v-if="qingsuTagList.length" class="tags-view">
          <li
            v-for="(tag, index) in qingsuTagList"
            :key="index"
            @click.stop="onTagClick(tag, 'qingsu')"
            class="qingsu-tag"
          >
            <img
              v-if="tag.type === 'icon'"
              :src="
                require(`../../../../images/platform/homepage/icon-${tag.name}.png`)
              "
            />
            <div v-else :class="tag.type">
              {{ tag.name }}
            </div>
          </li>
        </ul>
      </div>
      <!-- 普通用户标签 -->
      <normalLabel v-else />

      <yxlMore
        :lineClamp="2"
        :info="personalDesc"
        @hook:updated="yxlMoreUpdated"
        @setShowAllCallback="setShowAllCallback"
        class="person-more-text"
      />
    </div>
    <!-- 咨询师入驻标准弹窗 -->
    <consultStandardPopup :show.sync="isShowStandardPopup" />
    <!-- 咨询师特色弹窗 -->
    <consultFeaturePopup :show.sync="showFeaturePopup" />
    <!-- 倾听师等级弹窗 -->
    <qingsuLevelModel :show.sync="showQingsuLevelModel" />
    <!-- 倾听师标签弹窗 -->
    <qingsuTagModel :show.sync="showQingsuTagModel" :tag="qingsuTag" />
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import consultStandardPopup from '../consultTeacher/consultStandardPopup.vue'
import { getPlatform } from 'app/frontend-lib/tools/getPlatform'
import qingsuLevelModel from 'component/platform/homepage/qingsuTeacher/qingsuLevelModel.vue'
import dataPanel from 'component/platform/homepage/common/dataPanel.vue'
import { Icon as VanIcon } from 'vant'
import yxlMore from 'component/common/yxlMore.vue'
import { userInfoShowAllStat } from 'utils/homepageUtil.js'
import consultFeaturePopup from 'component/platform/homepage/consultTeacher/consultFeaturePopup.vue'
import qingsuTagModel from 'component/platform/homepage/qingsuTeacher/qingsuTagModel.vue'
import normalRelation from 'component/platform/homepage/normalUser/normalRelation.vue'
import normalLabel from 'component/platform/homepage/normalUser/normalLabel.vue'

export default {
  components: {
    consultStandardPopup,
    qingsuLevelModel,
    VanIcon,
    yxlMore,
    dataPanel,
    consultFeaturePopup,
    qingsuTagModel,
    normalRelation,
    normalLabel
  },
  data() {
    return {
      isShowStandardPopup: false,
      showQingsuLevelModel: false,
      isPc: false,
      showFeaturePopup: false,
      showQingsuTagModel: false,
      qingsuTag: ''
    }
  },
  computed: {
    ...mapGetters({
      isConsultTeacher: 'homepage/isConsultTeacher',
      isQingtingTeacher: 'homepage/isQingtingTeacher'
    }),
    basicInfo() {
      return this.$store.state.homepage.basicInfo || {}
    },
    qingsuBaseInfo() {
      return this.basicInfo.qing_info || {}
    },
    // 是否专业咨询师
    zxProTeacher() {
      if (!this.isConsultTeacher) {
        return false
      }
      let { identities } = this.basicInfo
      identities = Array.isArray(identities) ? identities : []
      return identities.find(item => item.business === 'zixun_pro_teacher')
    },
    qingsuLevel() {
      if (!this.isQingtingTeacher) {
        return ''
      }
      const { grade } = this.qingsuBaseInfo
      return (grade && grade.grade_level) || ''
    },
    personalDesc() {
      return this.isConsultTeacher
        ? this.basicInfo.honor
        : this.basicInfo.brief || 'ta还没填写简介呢。'
    },
    consutTagList() {
      const { consult_identities } = this.basicInfo
      let arr = Array.isArray(consult_identities) ? consult_identities : []
      return arr
    },
    qingsuTagList() {
      // 外部渠道不显示
      if (this.isOuterChannel) {
        return []
      }
      let tags = this.qingsuBaseInfo.like_labels
      if (!this.isQingtingTeacher || !tags) {
        return []
      }
      tags = tags.slice(0, 3)
      return tags.map(tag => {
        let result = null
        if (tag.includes('已入驻') || tag.includes('咨询师资质')) {
          result = {
            type: 'tag',
            name: tag
          }
        } else {
          switch (tag) {
            case '热门TOP30':
              result = {
                type: 'icon',
                name: 'qingsu-top'
              }
              break
            case '近期入驻TOP50':
              result = {
                type: 'icon',
                name: 'new-join'
              }
              break
            case '好评TOP50':
              result = {
                type: 'icon',
                name: 'good-rate'
              }
              break
            case '人气飙升TOP50':
              result = {
                type: 'icon',
                name: 'qingsu-hot'
              }
              break
            case '快速响应':
              result = {
                type: 'icon',
                name: 'quick-reply'
              }
              break
            case '12.12嘉年华':
              result = {
                type: 'icon',
                name: 'anniversary'
              }
              break
            default:
              result = {
                type: 'text',
                name: tag
              }
          }
        }
        result.label = tag
        return result
      })
    },
    isShowAllTags() {
      if (this.isConsultTeacher && this.consutTagList.length > 3) {
        return true
      }
      return false
    },
    isOuterChannel() {
      const { cid = '', cp_channel_id = '' } = this.$route.query
      return cid || cp_channel_id
    },
    isMyself() {
      const { userinfo } = this.$store.state
      return userinfo?.id === this.basicInfo.id
    }
  },
  mounted() {
    this.isPc = getPlatform().isPc
  },
  methods: {
    showImgViewer() {
      this.$trackEvent('newprofilepages_avatar', {})
      this.$emit('showImgViewer')
    },
    openStandardPopup() {
      this.$trackEvent('newprofilepages_psychologicalcounselor_label', {})
      this.isShowStandardPopup = true
    },
    onClickQingsuLevel() {
      this.$trackEvent('newprofilepages_listenertag', {
        tag_type: '等级标签'
      })
      this.showQingsuLevelModel = true
    },
    handleClickNamecard() {
      this.$trackEvent('newprofilepages_namecard', {})
      this.$emit('openSharePosterModal')
    },
    onTagClick(tag, type) {
      if (type === 'consult') {
        this.$trackEvent('newprofilepages_teachertags', {})
        this.showAllTags()
      } else {
        this.$trackEvent('newprofilepages_listenertag', {
          tag_type: '推荐标签'
        })
        this.qingsuTag = tag.label
        this.showQingsuTagModel = true
      }
    },
    yxlMoreUpdated() {
      this.$emit('updated')
    },
    setShowAllCallback(showall) {
      if (this.isQingtingTeacher && !this.isConsultTeacher) {
        this.$trackEvent('newprofilepages_listener_selfintroduction_all')
        return
      }
      userInfoShowAllStat.call(this, showall)
    },
    showAllTags() {
      this.showFeaturePopup = true
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~lib/scss/functions.scss';
.homepage-personal-info {
  margin-top: -52px;
  &::after {
    content: '';
    display: block;
    width: 100%;
    height: 16px;
    background: #fafafa;
  }
  .content {
    padding: 0 32px 40px 32px;
  }
  .info-top {
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    margin-bottom: 40px;
    &.pg {
      margin-bottom: 66px;
    }
    .top-avatar {
      width: 100px;
      height: 100px;
      border-radius: 50%;
      object-fit: cover;
      z-index: 2;
    }
  }
  .info-base {
    display: flex;
    align-items: center;
    .name-and-level {
      display: flex;
      align-items: center;
    }
    .name {
      font-size: 38px;
      line-height: 42px;
      font-weight: 600;
      max-width: 370px;
      color: #21252d;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      &.m {
        max-width: 200px;
      }
    }
    .zxteacher {
      display: flex;
      align-items: center;
      height: 36px;
      background: #fcf0dc linear-gradient(180deg, #fef5e6 0%, #f5e6b2 100%);
      border-radius: 17px;
      padding-right: 12px;
      margin-left: 16px;
      font-size: 20px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #a2762e;
      i {
        width: 30px;
        height: 30px;
        margin: 0 5px;
        background: url('~images/platform/homepage/zxteacher-tag-icon.png')
          center/30px 30px no-repeat;
      }
    }
    .qingsu-level {
      margin-left: 16px;
      width: 152px;
      height: 36px;
    }
    .business-card {
      display: flex;
      justify-content: space-evenly;
      align-items: center;
      width: 92px;
      height: 42px;
      border-radius: 32px;
      border: 0.013334rem solid #6982fa;
      margin-left: auto;
      &.qingsu-own {
        border: 0.013334rem solid #ff745b;
        span {
          color: #ff745b;
        }
        i {
          background: url('~images/platform/homepage/icon-qingsu-qr.png')
            no-repeat center/100%;
        }
      }
      i {
        display: inline-block;
        width: 20px;
        height: 20px;
        background: url('~images/platform/homepage/card-2.png') no-repeat;
        background-size: 100%;
      }
      span {
        font-size: 20px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #6982fa;
        line-height: 42px;
      }
    }
  }
  .tags-view {
    position: relative;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    &:first-child {
      margin-top: 9px;
    }
    &.m {
      width: calc(10rem - 70px);
    }
    li:not(:last-child) {
      margin-right: 20px;
    }
    .consult-tag {
      height: 30px;
      background: #fff;
      border-radius: 6px;
      border: 0.013334rem solid #6982fa;
      padding-right: 9px;
      font-size: 22px;
      color: #6982fa;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 18px;
      img {
        width: 30px;
        height: 30px;
        background: #6982fa;
        border-radius: 6px 0px 0px 6px;
        margin-left: -0.013334rem;
        margin-right: 8px;
        padding: 7px;
        box-sizing: border-box;
      }
    }
    .qingsu-tag {
      font-size: 22px;
      color: #ffa202;
      border-radius: 6px;
      background: transparent;
      margin-top: 20px;
      img {
        height: 30px;
        width: auto;
      }
      .tag,
      .text {
        display: flex;
        align-items: center;
        padding: 0 8px;
        height: 30px;
        border: 0.013334rem solid #ffa202;
        font-size: 22px;
        border-radius: 6px;
      }
    }
    .icon-arrow {
      position: absolute;
      right: -20px;
      top: 17px;
      width: 56px;
      height: 36px;
      text-align: center;
      line-height: 36px;
      color: #6982fa;
    }
  }
  .person-more-text {
    margin-top: 30px;
  }
  .yxl-more {
    font-size: 24px;
    color: #6c798c;
  }
}
</style>
